module.exports = __webpack_public_path__ + "static/media/BLUSH_3021.9e133a06.jpg";